import { useQuery } from "@tanstack/react-query";
import styled from "styled-components";
import CasesApi from "@/api/cases/index.js";
import Loader from "@/components/Loader.js";
import { CopyableDetailRow } from "./CopyableDetailRow";

interface CaseInfoCardProps {
  className?: string;
  caseInfo: { uuid: string };
}

export const CaseInfoCard = styled(
  ({ className, caseInfo }: CaseInfoCardProps) => {
    const { data, isPending, isError } = useQuery({
      queryKey: ["entity-info", "case", caseInfo.uuid],
      queryFn: () => CasesApi.getCases({ uuid: caseInfo.uuid }),
    });

    if (isPending) return <Loader />;

    if (isError) {
      return (
        <div className={className}>
          <h4>Unable to load case details</h4>
        </div>
      );
    }

    const caseData = data?.[0];

    if (!caseData) {
      return (
        <div className={className}>
          <h4>Case not found</h4>
        </div>
      );
    }

    return (
      <div className={className}>
        <h4>{caseData.case_ref}</h4>
        <CopyableDetailRow label="Case Number" value={caseData.case_number} />
        <CopyableDetailRow label="Client" value={caseData.client_name} />
        <CopyableDetailRow
          label="Organization"
          value={caseData.client_organization}
        />
        <CopyableDetailRow label="Status" value={caseData.case_status} />
        <CopyableDetailRow label="Progress" value={caseData.progress} />
      </div>
    );
  }
)`
  display: flex;
  flex-direction: column;
  gap: 2px;
  color: ${({ theme }) => theme.palette.text.primary};

  h4 {
    margin: 0 0 4px 0;
    font-size: 0.75rem;
  }
`;

export default CaseInfoCard;
